// a helper function
export function shouldSkipIdVerification(outages){
    let shouldSkip = false;
    outages.forEach((element) => {
      const start = element.start;
      const end = element.end;
      const fiveMunitesBeforeStart = new Date(
        new Date(start).getTime() - 5 * 60000
      ).toISOString();
      const now = new Date().toISOString();
      if (now >= fiveMunitesBeforeStart && now <= end) {
        shouldSkip = true;
      }
    });
    return shouldSkip
}

